import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import React from "react";

const linkClasses =
    "inline-flex items-center gap-1 text-sm text-brand-600 hover:text-brand-700";

interface ExternalRecordLinkProps {
    url: string;
    partnerName: string;
}

export const ExternalRecordLink: React.FC<ExternalRecordLinkProps> = ({
    url,
    partnerName,
}) => (
    <a href={url} target="_blank" rel="noreferrer noopener" className={linkClasses}>
        <ArrowTopRightOnSquareIcon className="w-4 h-4" />
        Open in {partnerName}
    </a>
);

export const ExternalRecordLinkCompact: React.FC<{ url: string }> = ({ url }) => (
    <a href={url} target="_blank" rel="noreferrer noopener" className={linkClasses}>
        <ArrowTopRightOnSquareIcon className="w-4 h-4" />
        Open
    </a>
);
